<template>
<nav>
  <div class="nav-wrapper green">
    <div class="container">
      <router-link to="/" class="brand-logo">Employee Manager</router-link>
    </div>
  </div>
</nav>
</template>

<script>
export default {
name: 'NavBar',
// data() {
//     return {
        
//     }
// },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue